<template>
  <div class="relative mt-0 w-full">
    <div class="absolute right-0 top-2 w-52 md:w-64 shadow-md bg-grey-academy-150 flex flex-col
    text-center font-sans-serif p-4 rounded text-base md:text-lg">
      {{ $t('payments.gain') }}:
      <strong>{{ user.teacher.waiting_money ?
        formatter.format(user.teacher.waiting_money/100) : formatter.format(0) }}</strong>
    </div>
    <div class="my-5 py-3 pl-2 text-xl lg:text-3xl font-bold w-full pt-32">
      <h1 class="w-full mx-auto uppercase">
        {{ $t('payments.receiveds') }}
      </h1>
    </div>
    <div class="mt-10 bg-background-academy p-4 px-2 md:px-10 font-sans-serif rounded"
      v-if="receivedPayments.length > 0">
      <received-payment-row
      class="my-3"
        v-for="payment in receivedPayments"
        :key="payment.id"
        :payment="payment" />
    </div>
    <div v-if="receivedPayments.length === 0 && !isLoadingReceived" class="pt-10">
      {{ $t('payments.noReceived') }} </div>
    <div :class="isLoadingReceived ? 'pt-6' : ''" v-if="isLoadingReceived">
      <Skeleton :loading="isLoadingReceived" lineHeight="2"/>
    </div>
    <div class="my-5 py-3 pl-2 text-xl lg:text-3xl font-bold w-full pt-32">
      <h1 class="w-full mx-auto uppercase">
        {{ $t('payments.lessons') }}
      </h1>
    </div>
    <div class="mt-10 bg-background-academy p-4 px-2 md:px-10 font-sans-serif rounded"
    v-if="lessonPayments.length>0">
      <lesson-payment-row
      class="my-3"
        v-for="payment in lessonPayments"
        :key="payment.id"
        :payment="payment" />
    </div>
    <div v-if="lessonPayments.length === 0 && !isLoadingLesson" class="pt-10">
      {{ $t('payments.noLessons') }} </div>
    <div :class="isLoadingLesson ? 'pt-6' : ''" v-if="isLoadingLesson">
      <Skeleton :loading="isLoadingLesson" lineHeight="2"/>
    </div>
  </div>
</template>

<script>
import { getTeacherLessonPayments, getTeacherReceivedPayments } from '@/services/TeacherService';
import { mapGetters } from 'vuex';
import { Skeleton } from '@/components/Skeleton/src/index';
import LessonPaymentRow from './LessonPaymentRow.vue';
import ReceivedPaymentRow from './ReceivedPaymentRow.vue';

export default {
  components: { LessonPaymentRow, ReceivedPaymentRow, Skeleton },

  data() {
    return {
      receivedPayments: [],
      lessonPayments: [],

      isLoadingLesson: false,
      isLoadingReceived: false,
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  created() {
    this.getLessonPayments();
    this.getReceivedPayments();
  },

  methods: {
    getLessonPayments() {
      this.isLoadingLesson = true;
      getTeacherLessonPayments(this.user.teacher.id).then(({ data }) => {
        this.lessonPayments = data;
        this.isLoadingLesson = false;
      });
    },

    getReceivedPayments() {
      this.isLoadingReceived = true;
      getTeacherReceivedPayments(this.user.teacher.id).then(({ data }) => {
        this.receivedPayments = data;
        this.isLoadingReceived = false;
      });
    },
  },

};
</script>
